<template>
  <div class="drawer-detail">
    <div v-for="field in ['项目名称','部门','行业']" :key="field" class="search-row">
      <span class="label">{{translateTag[field]||field}}:</span>
      <span class="value"> {{ project[field] || '--' }}</span>
    </div>
    <div class="search-row">
      <span class="label">工作地点:</span>
      <span class="value"> {{ project['办公地'] && project['办公地'].join('、') || '--' }}</span>
    </div>
    <div class="search-row">
      <span class="label">关键面试决策人:</span>
      <span v-for="(hr, k) in project.interviewer" :key="k" class="link-text" style="margin:0 5px 5px 0" @click="showRadish(hr)">{{hr.姓名}}</span>
    </div>
    <div class="search-row">
      <span class="label">岗位性质:</span>
      <span v-if="project.保密" style="margin:0 5px 5px 0">保密</span>
      <span v-if="project.独家" style="margin:0 5px 5px 0">独家</span>
      <span v-if="project.替换" style="margin:0 5px 5px 0">替换</span>
      <span v-if="project.新建" style="margin:0 5px 5px 0">新建</span>
      <span v-if="project.紧急重要" style="margin:0 5px 5px 0">紧急重要</span>
      <span v-if="project.刚需必成" style="margin:0 5px 5px 0">刚需必成</span>
    </div>
    <div class="field-type">
      <span class="label">岗位描述和岗位要求:</span>
      <div :class="[project['岗位描述和岗位要求']?'':'gray-text','value project-pre']">
        <p v-if="project['岗位描述和岗位要求']">{{project['岗位描述和岗位要求']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('岗位描述和岗位要求')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div class="field-type">
      <span class="label">核心要求:</span>
      <div :class="[project['核心要求汇总']?'':'gray-text','value project-pre']">
        <p v-if="project['核心要求汇总']">{{project['核心要求汇总']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('核心要求汇总')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div class="field-type">
      <span class="label">
        岗位薪酬:
        <span class="svg-text-btn" type="text" @click="viewSalary">
          <svg t="1621844337690" fill="#409EFF" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11003" width="12" height="12"><path d="M490.666667 117.333333a32 32 0 0 1 3.072 63.850667L490.666667 181.333333H192a10.666667 10.666667 0 0 0-10.496 8.746667L181.333333 192v640a10.666667 10.666667 0 0 0 8.746667 10.496L192 842.666667h640a10.666667 10.666667 0 0 0 10.496-8.746667L842.666667 832V533.333333a32 32 0 0 1 63.850666-3.072L906.666667 533.333333v298.666667a74.666667 74.666667 0 0 1-70.570667 74.56L832 906.666667H192a74.666667 74.666667 0 0 1-74.56-70.570667L117.333333 832V192a74.666667 74.666667 0 0 1 70.570667-74.56L192 117.333333h298.666667z m341.333333 0a74.666667 74.666667 0 0 1 74.56 70.570667L906.666667 192v128a32 32 0 0 1-63.850667 3.072L842.666667 320v-77.226667A781.781333 781.781333 0 0 0 455.168 627.2a32 32 0 1 1-58.112-26.816A845.738667 845.738667 0 0 1 823.296 181.333333H704a32 32 0 0 1-3.072-63.850666L704 117.333333h128z" p-id="11004"></path></svg>
          行业薪酬
        </span>
      </span>
      <div class="mb10" style="display: flex;justify-content: space-around;">
        <span>固薪：{{guxin}}</span>
        <span>全薪：{{quanxin}}</span>
      </div>
      <div :class="[project['岗位薪酬备注']?'':'gray-text','value project-pre']">
        <p v-if="project['岗位薪酬备注']">{{project['岗位薪酬备注']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('岗位薪酬备注')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <MarketMoney ref="MarketMoney"></MarketMoney>
  </div>
</template>
<script>
import MarketMoney from '../../../../../radish/src/components/market-money'

const dateFormat = require('dateformat')

export default {
  components:{ MarketMoney },
  props: {
    company: { type: Object, default: () => ({}) },
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      typeOneFields:['项目名称','部门','行业','办公地',],
      fields: [
        '项目名称',
        '部门',
        '行业',
        '办公地',
        '关键面试决策人',
        '保密',
        '独家',
        '替换',
        '新建',
        '紧急重要',
        '刚需必成',
        '岗位描述和岗位要求',
        '核心要求汇总',
        '岗位薪酬',
        '岗位薪酬备注',
        '最低固薪',
        '最高固薪',
        '最低全薪',
        '最高全薪',
      ],
      translateTag: {
        项目名称: '岗位名称',
        部门: '部门名称',
        行业: '行业',
        核心要求汇总:'核心要求',
        岗位薪酬备注:'岗位薪酬',
      },
      arrayFields: ['办公地', '年龄要求', '工作年限', '年薪范围', '月薪范围', '专业职级'],
      dateFields: ['startTime', 'guaranteeTime', 'indroduceTime'],
      formatRangeFields: ['年龄要求', '工作年限', '年薪范围', '月薪范围'],
      formatRangeMap: {
        年龄要求: '岁',
        工作年限: '年',
        年薪范围: '万',
        月薪范围: '万',
      },
    }
  },
  computed: {
    guxin() {
      if (this.project.最低固薪 && this.project.最高固薪) {
        return `${this.project.最低固薪}万-${this.project.最高固薪}万`
      } else if (this.project.最低固薪) {
        return `${this.project.最低固薪}万`
      } else if (this.project.最低固薪) {
        return `${this.project.最高固薪}万`
      } else {
        return ''
      }
    },
    quanxin() {
      if (this.project.最低全薪 && this.project.最高全薪) {
        return `${this.project.最低全薪}万-${this.project.最高全薪}万`
      } else if (this.project.最低全薪) {
        return `${this.project.最低全薪}万`
      } else if (this.project.最低全薪) {
        return `${this.project.最高全薪}万`
      } else {
        return ''
      }
    },
  },
  methods: {
    quickEdit(field){
      const { translateTag, project } = this
      this.$emit('quickEdit',{
        value: project[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          try {
            await app.service('project').modify({ id: this.project._id, param:{ [field]: v } })
            this.$message.success(`修改成功`)
            this.$set(this.project,field,v)
          } catch (error) {
            this.$message.error(`modify:${error.message}`)
          }
        },
      })
    },
    viewSalary() {
      if ((this.project.行业 || this.company.行业) && this.project.职能模块) {
        this.loadSalary()
      } else {
        this.$message('请先填写职能模块、行业')
      }
    },
    loadSalary() {
      this.$refs.MarketMoney.open({
        行业: this.project.行业 || this.company.行业,
        职能模块: this.project.职能模块,
        细分职能:this.project.细分职能,
        擅长方向:this.project.擅长方向,
        职级:this.project.职级,
      })
    },
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts._id}`, '_blank')
    },
    getValue(field) {
      const { project, arrayFields, dateFields, formatRangeFields, formatRangeMap, formatRange } = this
      const value = project[field]
      if (!value) return ''
      if (arrayFields.includes(field)) {
        if (formatRangeFields.includes(field)) return formatRange(value, formatRangeMap[field])
        return Array.isArray(value) ? value.filter(v => v).join('、') : value
      } else if (dateFields.includes(field)) {
        return dateFormat(new Date(value), 'yyyy-mm-dd')
      } else {
        return value
      }
    },
    formatRange(arr, str) {
      if (!arr || arr.length === 0 || (!arr[0] && !arr[1])) {
        return '--'
      } else if (arr.length === 1) {
        return `${arr[0]}${str}以上`
      } else if (!arr[0]) {
        return `${arr[1]}${str}以下`
      } else if (!arr[1]) {
        return `${arr[0]}${str}以上`
      } else {
        return `${arr[0]}-${arr[1]}${str}`
      }
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.branch-title {
  min-width: 50px;
}
.branch-tag {
  display: inline-block;
  background-color: #409eff;
  color: #fff;
  min-width: 200px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  margin-bottom: 4px;
  cursor: pointer;
}
.ml15 {
  margin-left: 15px;
}
pre.notriangle.value::after {
  border-bottom-color: transparent;
}
.svg-text-btn{
  cursor: pointer;
  color: #409eff;
  display: inline-flex;
  align-items: center;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
